import React from 'react';
import {Pagination} from 'react-admin';

const PostPagination = props => <Pagination rowsPerPageOptions={[10,100,500,1000,9999]} {...props} />


export default PostPagination;
